import { ButtonSize } from "../Button";
import { LoadingIndicatorSize } from "../LoadingIndicator";

export function mapButtonSizeToLoadingIndicatorSize(size: ButtonSize | undefined): LoadingIndicatorSize | undefined {
  switch (size) {
    case "xxl":
      return "xl";
    case "xs":
      return "sm";
    default:
      return size;
  }
}